import { motion } from "framer-motion";
import { Check } from "lucide-react";

export default function About({ data }) {
  return (
    <section id="about" data-testid="about-section" className="py-24 lg:py-32 bg-alabaster">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="lg:col-span-5 relative"
        >
          <div className="relative aspect-[4/5] overflow-hidden">
            <img
              data-testid="about-image"
              src={data.image}
              alt="Personal Trainer"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -bottom-6 -right-6 hidden md:block bg-gold text-onyx px-6 py-5">
            <p className="text-3xl font-serif">10+</p>
            <p className="text-xs tracking-[0.2em] uppercase mt-1">Anos de experiência</p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="lg:col-span-7"
        >
          <p className="overline mb-4" data-testid="about-overline">{data.overline}</p>
          <h2
            data-testid="about-title"
            className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light text-onyx leading-tight"
          >
            {data.title}
          </h2>
          <div data-testid="about-bio" className="mt-6 text-onyx/80 text-lg leading-relaxed space-y-4">
            {(data.bio || "").split("\n\n").map((para, i) => (
              <p key={i}>{para}</p>
            ))}
          </div>
          {data.credentials && data.credentials.length > 0 && (
            <ul className="mt-8 grid sm:grid-cols-2 gap-3">
              {data.credentials.map((c, i) => (
                <li
                  key={i}
                  data-testid={`about-credential-${i}`}
                  className="flex items-start gap-3 text-onyx/80"
                >
                  <Check size={16} className="text-gold mt-1 flex-shrink-0" strokeWidth={2.5} />
                  <span className="text-sm">{c}</span>
                </li>
              ))}
            </ul>
          )}
        </motion.div>
      </div>
    </section>
  );
}
